import { useNewProfiles } from 'data/profiles'
import { Table } from './Table'
import Text, { TextTypes } from 'Components/Ui-Kits/Text'
import { useAppTranslation } from 'i18n/hooks'

export const NewCustomers = () => {
  const { profiles } = useNewProfiles()
  const { t } = useAppTranslation()

  return (
    <>
      <Text as="h2" type={TextTypes.HEADING_34}>
        {t('newCustomers')}
      </Text>
      <Table items={profiles} />
    </>
  )
}
